/* anvone Bundle-PDP — vanilla JS (2026-08-20). Ableitung von anv-pdp.js:
   pack-varianten-state statt selling-plan-state; ATC IMMER übernommen (atomarer add:
   hauptvariante + ggf. flasche-gift mit _anvone_welcome_gift, wie welcome-kit v2).
   Gallery, sticky, expanders, reveals unverändert übernommen. */
(function () {
  'use strict';
  var root = document.getElementById('anv-pdp');
  if (!root) return;

  var form = document.getElementById('anv-product-form');
  var idInput = root.querySelector('[data-anv-variant-id]');

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- pack selection ---------- */
  var packs = qa('[data-anv-pack]');
  var giftScript = q('[data-anv-bundle-gift]');
  var giftVariant = null;
  try { giftVariant = giftScript ? JSON.parse(giftScript.textContent).id : null; } catch (e) { giftVariant = null; }

  function selected() {
    return packs.filter(function (p) { return p.classList.contains('is-active'); })[0] || null;
  }

  /* dynamische garantie (Max 2026-08-20): 3er = 60 tage, 1er/2er = 30 tage — ALLE
     garantie-nennungen der seite folgen der auswahl (akkuratheit statt statischem "60").
     mechanik: text-knoten in den zielcontainern, "30/60" direkt vor "tage/tagen/-tage"
     wird ersetzt; das badge (data-anv-gdays) wird direkt gesetzt. */
  var GDAYS_CONTAINERS = ['.anv-secure', '.anv-gband', '.anv-cmp', '.anv-bsel__guarantee'];
  var GDAYS_RE = /\b(30|60)(?=(\s|-| )?tage)/g;
  function swapGuaranteeDays(days) {
    document.querySelectorAll('[data-anv-gdays]').forEach(function (el) { el.textContent = days; });
    GDAYS_CONTAINERS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (box) {
        var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (GDAYS_RE.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(GDAYS_RE, days);
          }
          GDAYS_RE.lastIndex = 0;
        }
      });
    });
  }

  function applyPackState() {
    var sel = selected();
    if (!sel) return;
    var vid = sel.getAttribute('data-anv-pack');
    var priceText = sel.getAttribute('data-anv-pack-price');
    var name = sel.getAttribute('data-anv-pack-name');
    if (idInput) idInput.value = vid;
    var price = q('[data-anv-atc-price]');
    if (price) price.textContent = priceText;
    var atc = q('[data-anv-atc]');
    if (atc) atc.disabled = sel.hasAttribute('data-anv-pack-soldout');
    /* sticky mirrors */
    var sPlan = q('[data-anv-sticky-plan]');
    var sPrice = q('[data-anv-sticky-price]');
    if (sPlan) sPlan.textContent = name;
    if (sPrice) sPrice.textContent = priceText;
    qa('[data-anv-opt]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-anv-opt') === vid);
    });
    var gdays = sel.getAttribute('data-anv-pack-gdays');
    if (gdays) swapGuaranteeDays(gdays);
  }

  function selectPack(vid) {
    packs.forEach(function (p) {
      var on = p.getAttribute('data-anv-pack') === vid;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    applyPackState();
  }

  packs.forEach(function (p) {
    if (p.hasAttribute('data-anv-pack-soldout')) return;
    p.addEventListener('click', function () { selectPack(p.getAttribute('data-anv-pack')); });
    p.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectPack(p.getAttribute('data-anv-pack')); }
    });
  });

  /* ---------- expanders (accordions + garantie ⓘ) ---------- */
  qa('[data-anv-expand]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('.anv-acc__item, .anv-secure__main');
      var panel = item ? item.querySelector('.anv-acc__panel, .anv-secure__panel') : null;
      if (!panel) return;
      var open = panel.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- sticky bar ---------- */
  var sticky = q('[data-anv-sticky]');
  var buybox = q('.anv-pdp__buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      var past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sticky.classList.toggle('show', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (!past) {
        var sel = sticky.querySelector('[data-anv-sticky-selector]');
        var ch = sticky.querySelector('[data-anv-sticky-chip]');
        if (sel) sel.classList.remove('open');
        if (ch) ch.setAttribute('aria-expanded', 'false');
      }
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(buybox);
  }
  var chip = q('[data-anv-sticky-chip]');
  var selector = q('[data-anv-sticky-selector]');
  if (chip && selector) {
    chip.addEventListener('click', function () {
      var open = selector.classList.toggle('open');
      chip.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && window.getComputedStyle(selector).position === 'fixed') {
        var barRect = sticky.getBoundingClientRect();
        selector.style.bottom = Math.max(0, window.innerHeight - barRect.top + 6) + 'px';
      }
    });
    qa('[data-anv-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        selectPack(b.getAttribute('data-anv-opt'));
        selector.classList.remove('open');
        chip.setAttribute('aria-expanded', 'false');
      });
    });
  }
  var stickyAtc = q('[data-anv-sticky-atc]');
  if (stickyAtc && form) stickyAtc.addEventListener('click', function () {
    var btn = q('[data-anv-atc]');
    if (btn) btn.click();
  });

  /* ---------- ATC: atomarer add (pack + ggf. gift) + Dawn drawer render ----------
     Capture-phase vor Dawns product-form handler — wir übernehmen den submit komplett. */
  if (form) {
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var atc = q('[data-anv-atc]');
      var spinner = atc ? atc.querySelector('.loading__spinner') : null;
      if (atc) { atc.setAttribute('aria-disabled', 'true'); atc.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');

      var sel = selected();
      var withGift = sel && sel.getAttribute('data-anv-pack-gift') === 'true' && giftVariant;
      var mainItem = { id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 };
      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var present = {};
          (cart.items || []).forEach(function (i) { present[i.variant_id] = true; });
          var items = [mainItem];
          if (withGift && !present[giftVariant]) {
            items.push({ id: giftVariant, quantity: 1, properties: { _anvone_welcome_gift: 'true' } });
          }
          var body = { items: items };
          if (cartEl && cartEl.getSectionsToRender) {
            body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status && resp.status !== 200) { window.location.href = '/cart'; return; }
          if (cartEl && cartEl.renderContents) {
            cartEl.classList.remove('is-empty');
            cartEl.renderContents(resp);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          if (atc) { atc.removeAttribute('aria-disabled'); atc.classList.remove('loading'); }
          if (spinner) spinner.classList.add('hidden');
        });
    }, true);
  }

  /* ---------- mobile gallery slider ↔ thumbs ---------- */
  var track = q('[data-anv-track]');
  var thumbs = qa('[data-anv-thumb]');
  if (track && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-anv-thumb'), 10);
        var slide = q('[data-anv-slide="' + i + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, 80);
    }, { passive: true });
  }

  /* ---------- reveals (shared with anv-sections.js — first script to run claims it) ---------- */
  if (!window.__anvRevealDone) {
    window.__anvRevealDone = true;
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
      }, { threshold: 0.1 });
      qa('[data-anv-reveal]', document).forEach(function (n) { rio.observe(n); });
      setTimeout(function () {
        qa('[data-anv-reveal]', document).forEach(function (n) {
          if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('in');
        });
      }, 1600);
    } else {
      qa('[data-anv-reveal]', document).forEach(function (n) { n.classList.add('in'); });
    }
  }

  applyPackState();
})();
